/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemsBronzeSubscriptionFormSubmissions } from '../../models/items-bronze-subscription-form-submissions';

export interface CreateItemsBronzeSubscriptionFormSubmissions$Params {

/**
 * What metadata to return in the response.
 */
  meta?: string;
      body?: (Array<ItemsBronzeSubscriptionFormSubmissions> | ItemsBronzeSubscriptionFormSubmissions)
}

export function createItemsBronzeSubscriptionFormSubmissions(http: HttpClient, rootUrl: string, params?: CreateItemsBronzeSubscriptionFormSubmissions$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: Array<ItemsBronzeSubscriptionFormSubmissions>;
}>> {
  const rb = new RequestBuilder(rootUrl, createItemsBronzeSubscriptionFormSubmissions.PATH, 'post');
  if (params) {
    rb.query('meta', params.meta, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: Array<ItemsBronzeSubscriptionFormSubmissions>;
      }>;
    })
  );
}

createItemsBronzeSubscriptionFormSubmissions.PATH = '/items/bronze_subscription_form_submissions';
